// extracted by mini-css-extract-plugin
module.exports = {"warning":"styles_warning__23UPv","warning_text":"styles_warning_text__16dF8","warning_close":"styles_warning_close__joP4i"};